const gridMixins = {
  methods: {
    postProcessPopup({ePopup, eventSource}) {
      if (eventSource) {
        // const sourceTop = eventSource.getBoundingClientRect().top + window.scrollY;
        // ePopup.style.top = `${sourceTop + 5}px`;
      }
    }
  }
}

const updateTotalDataMixin = {
  methods: {
    async updateTotalDataWith(event, updateFunc) {
      const items = [];
      event.api.forEachNodeAfterFilterAndSort((item) => {
        if (item.data?.id) {
          const { data: { id } } = item
          items.push(id);
        }
      });
      const params = { ids: items.toString() }
      event.api.showLoadingOverlay();
      try {
        await updateFunc(params)
      } catch (e) {
        console.log(e)
      }
      event.api.hideOverlay();
    }
  }
}

export { gridMixins, updateTotalDataMixin };



// WEBPACK FOOTER //
// ./src/mixins/index.js